// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sPVCQ","error":"styles_error__2YPQG","success":"styles_success__qK5PD"};